import { Button, Card, Col, Row, Tabs } from 'antd'
import axios from 'axios'
import moment from 'moment'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'
import CustomBreadcrumb from 'src/components/CustomBreadcrumb'
import CustomTag from 'src/components/CustomTag'
import * as api from 'src/configs/API'
import { GlobalContext } from 'src/pages/_app'

const { TabPane } = Tabs
function TuyenDungDetail() {
	let router = useRouter()

	const { systemCities } = useContext(GlobalContext)
	const [slug, setSlug] = useState(router.query.slug)
	const [breadscrumb, setBreadscrumb] = useState([])

	const [jobDetail, setJobDetail] = useState({})

	const getJobDetail = () => {
		axios
			.get(api.default.API_GET_JOB_DETAIL + '/' + router.query.slug)
			.then((res) => {
				setJobDetail(res.data.Data)
				let arr = [{ breadcrumbName: 'Vị trí', breadcrumbSubName: 'Vị trí', path: '/tuyen-dung' }]
				arr.push({
					breadcrumbName: res.data.Data.Name,
					breadcrumbSubName: res.data.Data.Name,
					path: '/tuyen-dung/' + router.query.slug,
				})
				setBreadscrumb(arr)
			})
			.catch((err) => {
				console.log(err)
			})
	}

	useEffect(() => {
		if (router.isReady) {
			getJobDetail()
		}
	}, [router.isReady])

	return (
		<div style={{ padding: '16px 0' }} className="page-recruitement-slug">
			<CustomBreadcrumb
				customRoute={[
					{
						breadcrumbName: 'Vị trí tuyển dụng',
						breadcrumbSubName: 'Vị trí tuyển dụng',
						path: '/tuyen-dung',
					},
					{
						breadcrumbName: router.query.name,
						breadcrumbSubName: router.query.name,
						path: '/tuyen-dung/' + router.query.slug + '?name=' + router.query.name,
					},
				]}
			/>
			<Card style={{ borderRadius: '5px' }}>
				<Row>
					<Col sm={24} xs={24} className="recruitment-detail-header">
						<b style={{ color: '#CC0000', fontSize: '20px' }}>{jobDetail.Name}</b>
						<div>
							{/* {jobDetail.Status == 0 ? 'Đang tuyển' : 'Hết hạn'} */}
							{moment(jobDetail.ExpiredDate).format('YYYY-MM-DD') <
							moment().format('YYYY-MM-DD') ? (
								<CustomTag type={'error'} text="Hết hạn" />
							) : (
								<CustomTag type={'info'} text="Đang tuyển" />
							)}
						</div>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xl={8} sm={12} xs={24}>
						<span style={{ color: '#5E6278' }}>Địa chỉ: </span>{' '}
						<b>
							{jobDetail.Cities?.map((item, index) => {
								return (
									<span key={index} style={{ fontSize: 16 }}>
										{systemCities.find((o) => o.Id == item)?.Name}
										{index == jobDetail.Cities.length - 1 ? '' : ' - '}
									</span>
								)
							})}
						</b>
					</Col>
					<Col xl={4} sm={12} xs={24}>
						<span style={{ color: '#5E6278' }}>Số lượng: </span>{' '}
						<b style={{ fontSize: 16 }}>{jobDetail.Quantity}</b>
					</Col>
					<Col xl={6} sm={12} xs={24}>
						<span style={{ color: '#5E6278' }}>Mức lương: </span>{' '}
						<b style={{ fontSize: 16 }}>{jobDetail.Salary}</b>
					</Col>
					<Col xl={6} sm={12} xs={24}>
						<span style={{ color: '#5E6278' }}>Hạn nộp hồ sơ: </span>{' '}
						<b style={{ fontSize: 16 }}>
							{moment(jobDetail.ExpiredDate).format('DD/MM/YYYY HH:mm:ss')}
						</b>
					</Col>
				</Row>
			</Card>
			<br />
			<Card style={{ borderRadius: '5px' }}>
				<Row>
					<Col lg={24}>
						<Tabs defaultActiveKey="1">
							<TabPane tab="Mô tả công việc" key="1">
								<div
									className="list-job-description"
									dangerouslySetInnerHTML={{ __html: jobDetail.JobDescription }}
								></div>
							</TabPane>
							<TabPane tab="Yêu cầu" key="2">
								<div
									className="list-job-description"
									dangerouslySetInnerHTML={{ __html: jobDetail.JobRequirement }}
								></div>
							</TabPane>
							<TabPane tab="Quyền lợi" key="3">
								<div
									className="list-job-description"
									dangerouslySetInnerHTML={{ __html: jobDetail.JobRight }}
								></div>
							</TabPane>
							<TabPane tab="Thông tin liên hệ" key="4">
								<div
									className="list-job-description"
									dangerouslySetInnerHTML={{ __html: jobDetail.JobFile }}
								></div>
							</TabPane>
						</Tabs>
						<br />
						<Button
							style={{
								borderRadius: '5px',
								backgroundColor: '#cc0000',
								color: 'white',
								border: 0,
								fontSize: 16,
							}}
							onClick={() => {
								router.push({
									pathname: '/tuyen-dung/ung-tuyen/[slug]',
									query: {
										slug: jobDetail?.Id,
										name: jobDetail?.Name,
									},
								})
							}}
							className={
								moment(jobDetail.ExpiredDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')
									? 'hidden-btn-recruitment'
									: ''
							}
						>
							Ứng tuyển ngay
						</Button>
					</Col>
				</Row>
			</Card>
		</div>
	)
}

export default TuyenDungDetail
